import React, { useEffect } from 'react'
import { Link, useSearchParams } from 'react-router-dom'

import { Button, Icon, PageTransition } from '@components/atoms'
import { migrationVideoStyles } from '@pages/MigrationVideo/styles'
import { authApi } from '@services/AuthApi'

const { background, container, videoResponsive, linkStyle } =
	migrationVideoStyles

export default function MigrationVideo() {
	const [migrationLink] = authApi.useMigrationLinkMutation()

	const [searchParams] = useSearchParams()

	useEffect(() => {
		if (searchParams.get('token')) {
			migrationLink({ token: searchParams.get('token') || '' })
			searchParams.set('token', '')
		}
	}, [migrationLink, searchParams])

	return (
		<PageTransition>
			<main className={background()}>
				<div className={container()}>
					<Icon title='logo DLS' name='logo' width={116} height={50} />

					<div className={videoResponsive()}>
						<iframe
							width='560'
							height='315'
							src='https://www.youtube.com/embed/W6Ta1cOAf5Q'
							title='YouTube video player'
							allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
						/>
					</div>

					<Link to='/login' className={linkStyle()}>
						<Button
							css={{
								marginBottom: '154px',
								width: '100%',
								'@md': {
									maxWidth: '500px',
								},
								borderRadius: '12px',
								border: '1px solid $neutral50',
								fontFamily: 'Roboto',
								_font: 'normal',
								fontSize: '$md',
								color: '$neutral120',
								lineHeight: '$xl',
								backgroundColor: '$neutral10',
								'&:hover': {
									color: '$blue20',
									borderColor: '$blue20',
								},
							}}
						>
							Fazer login agora
						</Button>
					</Link>
					<a
						href='https://pay.hotmart.com/T18298676N?off=ne7m7v3y&checkoutMode=10&_gl=1*19bnp3w*_ga*MTMzNjUyMzM4MC4xNjg4NDE4MDQ1*_ga_CMVBBHXKPX*MTY4ODc2MTA0My40LjAuMTY4ODc2MTA0My42MC4wLjA'
						className={linkStyle()}
					>
						<Button
							css={{
								marginBottom: '154px',
								width: '100%',
								'@md': {
									maxWidth: '500px',
								},
							}}
						>
							Vire premium agora
						</Button>
					</a>
				</div>
			</main>
		</PageTransition>
	)
}
